<!-- An icon to start/stop audio spot preview -->

<template>
  <div
    v-if="fileUrl"
    :class="{clickable: enabled}"
    :style="{
      width: previewWidth + 'px',
      height: previewHeight + 'px',
    }"
    @click="enabled ? togglePreview() : null"
  >
    <transition
      name="scale-transition"
      mode="out-in"
      duration="100"
    >
      <div
        v-if="!previewing"
        key="notPreviewing"
        :title="$t('radiospotPreview')"
      >
        <v-layout
          v-if="!closingtime"
          nowrap
          justify-center
          align-center
        >
          <v-img
            src="/static/radiospot_play_button.svg"
            :width="previewWidth"
            cover
          />
        </v-layout>
        <v-icon
          v-else
          :style="{
            'font-size': previewIconSize + 'em',
            width: previewWidth + 'px',
            height: previewHeight + 'px',
          }"
        >
          campaign
        </v-icon>
      </div>
      <v-icon
        v-else
        key="previewing"
        class="radiopreview-icon msr--text"
        :class="{
          pulse: !$store.state.common.runtimeEnv.firefox,
          safari: $store.state.common.runtimeEnv.safari,
        }"
        :style="{
          'font-size': previewIconSize - 0.5 + 'em',
          width: previewWidth + 'px',
          height: previewHeight + 'px',
        }"
      >
        pause
      </v-icon>
    </transition>
    <audio
      ref="audiopreview"
      preload="metadata"
      :src="fileUrl"
      class="hidden"
      @ended="enabled ? stopPreview() : null"
    />
  </div>
</template>

<script>
export default {
  props: {
    fileUrl: {
      type: String,
      required: true,
    },
    enabled: {
      type: Boolean,
      default: true,
    },
    closingtime: {
      type: Boolean,
      default: false,
    },
    /* Whether starting this stops all others using a global signal. */
    thereCanOnlyBeOne: {
      type: Boolean,
      default: true,
    },
    /** Default preview is tiny. We can increase it. */
    small: {
      type: Boolean,
      default: false,
    },
    medium: {
      type: Boolean,
      default: false,
    },
    full: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      previewing: false,
    };
  },
  computed: {
    previewWidth() {
      const defaultWidth = 96;
      if (this.small) {
        return defaultWidth * 2;
      }
      if (this.medium) {
        return defaultWidth * 3;
      }
      if (this.full) {
        return defaultWidth * 3.5;
      }
      return defaultWidth;
    },
    previewHeight() {
      return this.previewWidth / (16 / 9);
    },
    previewIconSize() {
      const defaultSize = 4;
      if (this.small) {
        return defaultSize * 2;
      }
      if (this.medium) {
        return defaultSize * 3;
      }
      if (this.full) {
        return defaultSize * 3.5;
      }
      return defaultSize;
    },
  },
  mounted() {
    this.$bus.$on('stop-mini-preview', () => {
      this.stopPreview();
    });
  },
  methods: {
    startPreview() {
      if (this.thereCanOnlyBeOne) {
        this.$bus.$emit('stop-mini-preview');
      }
      if (!this.$refs.audiopreview) {
        return;
      }
      this.$refs.audiopreview.play();
      this.previewing = true;
    },
    stopPreview() {
      if (!this.$refs.audiopreview) {
        return;
      }
      this.$refs.audiopreview.pause();
      this.$refs.audiopreview.currentTime = 0;
      this.previewing = false;
    },
    togglePreview() {
      this.previewing ? this.stopPreview() : this.startPreview();
    },
  },
};
</script>

<style scoped>
.hidden {
  display: none;
}

i.radiopreview-icon.pulse.safari {
  /* Pin x-position to avoid Safari issue with transform-origin. */
  transform: translateX(0%);
}

@keyframes pulse_animation {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.06);
  }
  100% {
    transform: scale(1);
  }
}

.pulse {
  animation-name: pulse_animation;
  animation-duration: 1.3s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}
</style>



// WEBPACK FOOTER //
// src/components/MiniPreviewAudio.vue